// extracted by mini-css-extract-plugin
module.exports = {"collapsed":"Collapse_collapsed__3s7pr","show":"Collapse_show__2bkzN","collapsing":"Collapse_collapsing__3OfMb"};